module.exports = __webpack_public_path__ + "img/subscription_cancelled.e2dc8035.png";